<div class="confirm-modal">
    <h1 mat-dialog-title>{{ title }}</h1>
    <div mat-dialog-content>
        <p *ngIf="!richMessage" class="confirm-message">
            {{ message }}
        </p>
        <p *ngIf="richMessage" class="confirm-message" [innerHTML]="richMessage"></p>
    </div>
    <div class="confirm-actions" mat-dialog-actions>
        <button mat-button class="secondary" (click)="onClose(false)">Cancel</button>
        <button mat-button class="primary" (click)="onClose(true)">
            {{ btnText }}
        </button>
    </div>
</div>
